import { useContent } from "contexts/contentContext/contentContext.js";
import React from "react";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import FunctionalHeader from "./FunctionHeader.js";
import SelectionHeader from "./SelectionHeader.js";

const HeadersContainer = ({ contentRef }) => {
  const { getFilesSelection } = useMailView();
  const { getBlackFridayTime, getBlackFridayTimeCookie } = useContent();

  return (
    <div
      className={`content-header${
        getBlackFridayTime() && getBlackFridayTimeCookie()
          ? " black-friday"
          : ""
      }`}
      ref={contentRef}
    >
      {getFilesSelection().length > 0 ? (
        <SelectionHeader />
      ) : (
        <FunctionalHeader />
      )}
    </div>
  );
};

export default HeadersContainer;
